var map = {
	"./tech-responsive-apache-airflow.svg": 1288,
	"./tech-responsive-artificial-intelligence.svg": 595,
	"./tech-responsive-azure.svg": 1289,
	"./tech-responsive-chatgpt.svg": 1290,
	"./tech-responsive-copilot.svg": 1291,
	"./tech-responsive-data.svg": 1292,
	"./tech-responsive-excel.svg": 1293,
	"./tech-responsive-git.svg": 1294,
	"./tech-responsive-google-cloud.svg": 1295,
	"./tech-responsive-google-sheets.svg": 1296,
	"./tech-responsive-hugging-face.svg": 1297,
	"./tech-responsive-jupyter.svg": 1298,
	"./tech-responsive-langchain.svg": 1299,
	"./tech-responsive-langgraph.svg": 1300,
	"./tech-responsive-llama.svg": 1301,
	"./tech-responsive-multiple.svg": 1302,
	"./tech-responsive-powerbi.svg": 1303,
	"./tech-responsive-powerpoint.svg": 1304,
	"./tech-responsive-python.svg": 1305,
	"./tech-responsive-r.svg": 1306,
	"./tech-responsive-shell.svg": 1307,
	"./tech-responsive-sql.svg": 1308,
	"./tech-responsive-tableau.svg": 1309,
	"./tech-responsive-theory.svg": 1310
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 543;